export function forOwn<T>(obj: T, fn: (value: T[keyof T], key: keyof T) => void | boolean) {
    for (const key of Object.getOwnPropertyNames(obj) as (keyof T)[]) {
        if (fn(obj[key], key) === false) {
            break;
        }
    }
}
